import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import DocumentType from 'modules/core/components/DocumentType'
import { FORMAT, stringToDate } from 'modules/core/lib/dates'

import type { IncidenceTaskDocument } from 'modules/bookkeepers/hooks/useGetIncidenceTaskDocuments'
import documentDownloadUrl from 'modules/documents/lib/documentDownloadUrl'

const buildDocumentDetails = (document: IncidenceTaskDocument) => {
  const date = stringToDate(document.createdAt, 'backend_datetime').format(FORMAT.ui_date_with_time)

  return `${date} - ${document.access?.fullName}`
}

interface Props {
  document: IncidenceTaskDocument
  disabled: boolean
  onDelete: () => void
}

const DocumentCard = ({ document, disabled, onDelete }: Props) => {
  return (
    <Box
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      paddingX="s24"
      paddingY="s16"
      background="grey000White"
    >
      <Box alignItems="center" justifyContent="spaceBetween" flexGrow flexDirection="row" gap="s16">
        <Box flexDirection="row" alignItems="center" gap="s16">
          {document.documentType && <DocumentType mimetype={document.documentType} />}
          <Box overflowX="hidden" maxWidth="s300">
            <Text.Normal weight="medium" ellipsis overflowWrap color="grey1000">
              {document.documentFilename}
            </Text.Normal>
            <Text.Normal size="200" ellipsis overflowWrap>
              {buildDocumentDetails(document)}
            </Text.Normal>
          </Box>
        </Box>
        <Box flexDirection="row" alignItems="center" gap="s4">
          <Button
            type="secondary"
            disabled={disabled}
            onClick={() => onDelete()}
            iconName="delete"
          />
          <Button.Router
            type="secondary"
            to={documentDownloadUrl(document.documentId, true)}
            blankTarget
            rel="noopener noreferrer"
            iconName="download"
          />
        </Box>
      </Box>
    </Box>
  )
}

export default DocumentCard
